import { stringIsNullOrEmpty } from "src/common/utilities";

export class methodBodyCreator{
    createBodyText(json:any):string{
        if(json==null)
            return '';
        let parts : IPart[] = json.map(x=>{
            let instance = new Factory().getInstance(x);
            instance.parse(x);
            return instance;
        });
        return parts.map(x=>x.getCode()).join('\n');
    }
} 
interface IPart{
    parse(json);
    getCode();
}
class jsCode implements IPart{
    public code:string;

    parse(json: any) {
        this.code = json.Code;
    }
    getCode() {
        let baseCode = '';
        if(stringIsNullOrEmpty(this.code)==false){
            baseCode = this.code;
        }
        const regex = /(let\s*[a-zA-Z0-9_]*\s*)(:\s*[a-zA-Z0-9_]*)?/gmu;
        const subst = `$1`;
        const result = baseCode.replace(regex, subst);
        return result;
    }
    
}
class CallServer implements IPart{
    private preCode:string;
    private address:string;
    private postCode:string;
    private inVariableName:string;
    private outVariableName:string;

    parse(json: any) {
        this.address = json.Address;
        this.preCode = new methodBodyCreator().createBodyText(json.InitializationCode);
        this.postCode = new methodBodyCreator().createBodyText(json.SettingCode);
        this.inVariableName = json.InVariableName;
        this.outVariableName = json.OutVariableName;
    }
    getCode() {
        return `
            let ${this.inVariableName}=${this.preCode};
            let ${this.outVariableName}=await this.__CallServer("${this.address}",${this.inVariableName});
            ${this.postCode};
        `;

    }

}
class createInstance implements IPart{
    public instanceType:string;
    public variableName:string;

    parse(json: any) {
        this.instanceType = json.InstanceType;
        this.variableName = json.VariableName;
    }
    getCode() {
        return `let ${this.variableName} = this.__CreateChildInstanceFromTypeName('${this.instanceType}');`;
    }
    
}
class CreatePaginationInfo implements IPart{
    public resultName:string
    public isStatic:boolean
    public currentPage:any
    public totalPages:any

    parse(json: any) {
        this.resultName = json.VariableName;
        this.isStatic = json.IsStatic;
        this.currentPage = json.CurrentPage;
        this.totalPages = json.Total;
        
    }
    getCode() {
        let current = null;
        let total = null;
        if(this.isStatic){
            current = this.currentPage;
            this.totalPages = total;
        }else{
            current = `this.[${this.currentPage}]`;
            total = `this.[${this.totalPages}]`;
        }
        return `let ${this.resultName} = this.__CreatePaginationInfo(${current},${total});`;
    }
    
}

class ShowPopup implements IPart{

    private variableName:string;
    private template : string;
    private height:string;
    private width:string;
    private waitUntilFinish: boolean;
    private returnVariableName: string;
    parse(json: any) {
        this.variableName = json.VariableName;
        this.template = json.Template;
        this.height = json.PopupHeight;
        this.width = json.PopupWidth;
        this.waitUntilFinish = json.WaitUntilFinish;
        this.returnVariableName = json.ReturnVariableName;
    }
    getCode() {
        let result = '';
        if(this.waitUntilFinish===true){
            result = `let ${this.returnVariableName} = await `;
        }
        function getsize(s:string):string{
            if(stringIsNullOrEmpty(s)){
                return 'null';
            }else{
                return `"${s}"`
            }
        }
        result = result + `this.__ShowPopup(${this.variableName},"${this.template}",${getsize(this.width)},${getsize(this.height)});`;
        return result;
    }

}
class Factory{
    getInstance(json:any):IPart{
        switch(json.Type){
            case "JsCode":
                return new jsCode();
            case "CreateInstance":
                return new createInstance();
            case "CallServer":
                return new CallServer();
            case "ShowPopup":
                return new ShowPopup();
            case "CreatePaginationInfo":
                return new CreatePaginationInfo();
        }
        return null;
    }
}